import { getAuth } from "firebase/auth";

export async function refreshSession() {
  const auth = getAuth();
  await auth.currentUser?.reload();
}
